export default "__VITE_ASSET__E2KrqpX8__"